import * as React from "react";
import classNames from "classnames";
import "./Container.scss";

export interface InterfaceContainer {
  children: React.ReactNode;
  spacing?: "normal" | "tight";
  align?: "flex-start" | "center" | "stretch" | "flex-end";
  justify?: "flex-start" | "center" | "flex-end";
}

export interface InterfaceColumn {
  children: React.ReactNode;
  width?: "one-third" | "one-half" | "two-thirds" | "full" | "auto";
}

function Container({
  children,
  spacing= "normal",
  align= "center",
  justify= "flex-start"
}: InterfaceContainer): JSX.Element {
  const className = classNames("nimbus-web--container", `spacing--${spacing}`);

  const containerStyle = {alignItems: align, justifyContent: justify};

  return (
    <div className={className} style={containerStyle}>
      {children}
    </div>
  );
}

export function Column({
  children,
  width,
}: InterfaceColumn): JSX.Element {
  const columnClassName = classNames("nimbus-web--column",
  `nimbus-web--column--width-${width}`);

  return (
    <div className={columnClassName}>
      <div className="nimbus-web--column-wrapper">
        {children}
      </div>
    </div>
  );
}

Container.Column = Column;

export default Container;